import { useEffect } from "react";
import { useSelector } from "react-redux";
import * as configUtils from "util/config";

const KonectaWidget = (props) => {
    const botId = configUtils.get("konecta.botId", "63bd597a1bf0c67fb9d5313d");
    const id = configUtils.get("konecta.id", "konecta-widget");
    const src = configUtils.get("konecta.src", "https://testkonecta.bibank.com.ar/iframe/konecta-widget.js");
    const baseUrl = configUtils.get("konecta.baseUrl", "https://testkonecta.bibank.com.ar/iframe");
    const { enabledAssistant } = useSelector((state) => state.session);
    const {loggedUser}= props;
    useEffect(() => {
        if (enabledAssistant) {
            const element = document.getElementById(id);
            const chat = document.getElementById("chat-konecta");
            if (element ) {
                element.remove();
            }
            if(chat){
                chat.remove();
            }
            const script = document.createElement("script");
            script.setAttribute("data-botId", botId);
            script.setAttribute("id", id);
            script.setAttribute("src", src);
            script.setAttribute("data-baseUrl", baseUrl);
            if(loggedUser){
                script.setAttribute("ctx-User-Fullname",loggedUser);
            }
            document.body.appendChild(script);
        } else {
            const element = document.getElementById(id);
            const chat = document.getElementById("chat-konecta");
            if (element && chat) {
                element.remove();
                chat.remove();
            }
        }
    }, [enabledAssistant,loggedUser]);
};

export default KonectaWidget;
